import React from 'react'
import { CloseIcon } from '@myxplor/icons'
import { FormButton } from '@myxplor/forms'

import './accs.css'

const options = [
  { value: 'ACC002', label: 'Evidence child is at risk' },
  { value: 'ACC003', label: 'Notice from State/Territory' },
  { value: 'ACC004', label: 'Other supporting documents' },
  { value: 'ACC005', label: 'Advise child no longer at risk' },
  { value: 'ACC006', label: 'Document related to Provider' },
  { value: 'ACC007', label: 'Document related to Service' },
  { value: 'ACC008', label: 'Evidence of exceptional circumstances' }
]

const truncate = (input) =>
  input.length > 64 ? `${input.substring(0, 32)}...` : input

const bytesToMb = (size) => size / 1024 / 1024

const validFileSize = (fileSize) => fileSize <= 5.4

const Attachment = ({ readOnly, idx, values, onChange, hasType }) => {
  const evidence = [...values.evidence]
  const fileSize = bytesToMb(evidence[idx].size)

  const removeAttachment = () => {
    evidence.splice(idx, 1)

    onChange('evidence', evidence)
  }

  const handleChangeDocumentType = (event) => {
    evidence[idx] = { ...evidence[idx], type: event.target.value }

    onChange('evidence', evidence)
  }

  return (
    <div>
      <div className='attachment'>
        <div className='attachmentDetails'>
          <div>
            {truncate(evidence[idx].name)}
            <strong>&nbsp;&nbsp;•&nbsp;&nbsp;</strong>
            {`${fileSize.toFixed(2)}mb`}
          </div>
          <div className='removeAttachmentButton'>
            {
              readOnly
                ? null
                : (
                  <FormButton left onClick={() => removeAttachment()}>
                    <CloseIcon left />
                  </FormButton>
                )
            }
          </div>
        </div>
        {!hasType && (
          <div>
            <select
              disabled={readOnly}
              name='evidence_type'
              defaultValue={'ACC002'}
              onChange={handleChangeDocumentType}
            >
              <optgroup label={'Choose Document Type'}>
                {options.map(({ label, value }, i) => (
                  <option key={i} value={value}>
                    {label}
                  </option>
                ))}
              </optgroup>
            </select>
          </div>
        )}
      </div>
      <div className='attachmentErrorMessage'>
        {validFileSize(fileSize) ? (
          <br />
        ) : (
          'Error: Attached file is larger than the total government file size limit. Remove it and try reducing the file size.'
        )}
      </div>
      <hr />
    </div>
  )
}

export default Attachment



// WEBPACK FOOTER //
// ./src/care-enrolments/accs/form/attachment.js